document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("header-menu details").forEach(function (detail) {
    detail.addEventListener("mouseover", function () {
      this.setAttribute("open", "true");
    });
    detail.addEventListener("mouseout", function () {
      this.removeAttribute("open");
    });
  });
});

const input = document.querySelector('predictive-search.small-hide .field__label');
const placeholders = [
    'Food & Confectionery Products',
    'Health & Wellness Products',
    'Personal Care Products',
    'Beauty Products',
    'Baby & Kids Products',
    'Household Essentials Products',
];
const searchFor = "Search for ";

let currentIndex = 0;
let charIndex = 0;
let isDeleting = false;
const typingSpeed = 50;
const deletingSpeed = 25; 
const pauseBetweenWords = 1000; 
function typeEffect() {
    const currentPlaceholder = placeholders[currentIndex]; 
    if (!isDeleting) {
        charIndex++;
    } else {
        charIndex--;
    }
    input.innerText = ('placeholder', searchFor + currentPlaceholder.slice(0, charIndex));
    if (!isDeleting && charIndex === currentPlaceholder.length) {
        setTimeout(() => {
            isDeleting = true;
            typeEffect(); 
        }, pauseBetweenWords);
        return;
    } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        currentIndex = (currentIndex + 1) % placeholders.length; 
    }
    const speed = isDeleting ? deletingSpeed : typingSpeed;

    setTimeout(typeEffect, speed);
}
if(input != null){
typeEffect();
}

